var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"co-home"},[_c('AppHeader'),_c('ParticlesBlock'),_c('AboutMe'),_c('MyResume'),_c('Skills'),_c('Work'),_c('MediumPosts'),_c('AppFooter'),_c('ScrollUpButton',{staticClass:"co-home__scroll-up-button"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }